import { Assets, Loader, Spritesheet } from "pixi.js";
import { AssessmentType, Assessor, IAssessorFactory, PitchAssessor,
	RhythmAssessor, RhythmAssessorHitMode, ScoreViewer } from "score_performance";
import { RaAssessmentVisualizer } from "./RaAssessmentVisualizer";

export class RaAssessorFactory implements IAssessorFactory {
	private _spriteSheet:Spritesheet;
	
	public assessBeats:boolean = false;
	
	public async loadAnimations():Promise<void> {
		try {
			let path = 'images/atlases/explosion.json';
			this._spriteSheet = await Assets.load(path) as Spritesheet;
		}
		catch(err){
			console.log(err);
		}
	}
	//https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-and-animations-with-pixijs5
	public getAssessor(assessType:AssessmentType, scoreViewer:ScoreViewer)
			:Assessor {
		let explosion = this._spriteSheet.animations["explosion"];
		switch (assessType){
			case AssessmentType.pitch:
				return new PitchAssessor(scoreViewer,  
					new RaAssessmentVisualizer(explosion));
			case AssessmentType.rhythmKeyboard:
				let assessor = new RhythmAssessor(scoreViewer,
					new RaAssessmentVisualizer(explosion));
				let mode = (this.assessBeats)
					? RhythmAssessorHitMode.keyboardAndBeat
					: RhythmAssessorHitMode.keyboard;
				assessor.setHitMode(mode);
				return assessor;
			case AssessmentType.none:
				return null;
			default: 
				throw 'unhandled AssessmentType: ${assessType.toString()}';
		}
	}
	
	
}